import React, { useState } from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { DatePicker } from "rsuite";
import { FaCaretDown } from "react-icons/fa";
import { MultiSelect } from 'primereact/multiselect';
import PhoneInput from "react-phone-input-2";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "English",
  "Hindi",
  "Bengali",
  "Telugu",
  "Marathi",
  "Tamil",
  "Urdu",
  "Gujarati",
  "Kannada",
  "Odia",
  "Malayalam",
  "Punjabi",
  "Assamese",
  "Maithili",
  "Santali",
  "Kashmiri",
  "Nepali",
  "Konkani",
  "Sindhi",
  "Dogri",
  "Manipuri",
  "Bodo",
  "Sanskrit",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function DoctorAddBasicInfo({ formik, isEditMode }) {
  const [selectedCities, setSelectedCities] = useState('');
  console.log(formik.values);
  const languages = [
    { name: "English", code: "EN" },
    { name: "Hindi", code: "HI" },
    { name: "Bengali", code: "BN" },
    { name: "Telugu", code: "TE" },
    { name: "Marathi", code: "MR" },
    { name: "Tamil", code: "TA" },
    { name: "Urdu", code: "UR" },
    { name: "Gujarati", code: "GU" },
    { name: "Kannada", code: "KN" },
    { name: "Odia", code: "OR" },
    { name: "Malayalam", code: "ML" },
    { name: "Punjabi", code: "PA" },
    { name: "Assamese", code: "AS" },
    { name: "Maithili", code: "MAI" },
    { name: "Santali", code: "SAT" },
    { name: "Kashmiri", code: "KS" },
    { name: "Nepali", code: "NE" },
    { name: "Konkani", code: "KOK" },
    { name: "Sindhi", code: "SD" },
    { name: "Dogri", code: "DO" },
    { name: "Manipuri", code: "MNI" },
    { name: "Bodo", code: "BR" },
    { name: "Sanskrit", code: "SA" }
  ];

  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
   .input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-text-fill-color: #000;
}

 .rs-input-group{
  border-radius: 6px;
  height: 40px;
  border-color:1px solid #18181dff;
   padding: 0.1rem !important;
  }
/* Custom style for 24px height */
.multiselect-24px .p-multiselect {
  height: 24px !important;
  padding: 2px 6px;
  font-size: 0.75rem;
  line-height: 1;
}

.multiselect-24px .p-multiselect-label {
height: 24px !important;
  padding: 3px 6px;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  font-family: 'Nunito Sans', sans-serif;
}

.multiselect-24px .p-multiselect-token {
  padding: 1px 4px;
  font-size: 0.7rem;
  margin: 1px 2px;
  
}
  .p-multiselect-panel .p-checkbox-box {
  border: 2px solid #213343 !important;  /* Dark border */
  border-radius: 4px;
  width: 16px;
  height: 16px;
}

/* Optional: dark background on check */
.p-multiselect-panel .p-checkbox-box.p-highlight {
  background: #213343;
  border-color: #213343;
}

/* Checkmark color (tick inside) */
.p-multiselect-panel .p-checkbox-icon {
  color: white;
  font-size: 12px;
}

.p-multiselect-item {
  padding: 4px 16px !important;
  font-size: 14px !important;  /* Optional: makes it more compact */
  line-height: 1.2;
}

/* Reduce padding around the entire list (top/bottom) */
.p-multiselect-items {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

/* Optional: Reduce space in checkboxes */
.p-checkbox {
  margin-right: 6px !important;
}

  `;

  const fileList =
    typeof formik.values.ProfilePicture === "string"
      ? [
        {
          name: formik.values.ProfilePicture,
          fileKey: 1,
          url: formik.values.ProfilePicture,
          status: "finished",
        },
      ]
      : formik.values.ProfilePicture instanceof File
        ? [
          {
            name: formik.values.ProfilePicture.name,
            fileKey: 2,
            file: formik.values.ProfilePicture,
            blobFile: formik.values.ProfilePicture,
            status: "finished",
          },
        ]
        : [];


  const [value, setValue] = useState(new Date());
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Basic Information
            </h5>
          </div>
        </div>
        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Full Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Full Name"
               autoComplete="fullname"
             //// autoComplete={"off"} // use a unique/random value
              value={formik.values.fullname}
              aria-autocomplete="none"
              name="fullname"
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z.\s]/g, ""); // allow only letters and spaces
                formik.setFieldValue("fullname", value);
              }}
              onBlur={formik.handleBlur}
              disabled={isEditMode}
            />
           
            {formik.touched.fullname && formik.errors.fullname && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.fullname}
              </div>
            )}
          </div>
        </div>



        <div className="col-md-3 col-12">
          <div className="input-block mb-3 position-relative">
            <label className="col-form-label lbl-VLJQLgvYMk">Gender<span className="text-danger">*</span></label>

            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Gender"
                name="gender"
                value={formik.values.gender}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="others">Others</option>
              </select>

              {/* Dropdown icon */}
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                }}
              />
            </div>

            {formik.touched.gender && formik.errors.gender && (
              <div style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}>
                {formik.errors.gender}
              </div>
            )}
          </div>
        </div>


        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Date of Birth<span className="text-danger">*</span>
            </label>
            <DatePicker
              name="dateofbirth"
              value={
                formik.values.dateofbirth
                  ? new Date(formik.values.dateofbirth)
                  : null
              }
              onChange={(value) => formik.setFieldValue("dateofbirth", value)}
              onBlur={() => formik.setFieldTouched("dateofbirth", true)}
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              oneTap
              style={{ width: "100%", height: "33px", borderRadius: "4px", }}
            />

            {/* <input
                    type="date"
                    class="form-control"
                    id="dob"
                    placeholder="DD/MM/YYYY"
                    name="dateofbirth"
                    value={formik.values.dateofbirth}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  /> */}
            {formik.touched.dateofbirth && formik.errors.dateofbirth && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "15px" }}
              >
                {formik.errors.dateofbirth}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Phone Number<span className="text-danger">*</span>
            </label>
            <PhoneInput
              country="in"
              onlyCountries={['in']}
              disableDropdown={true}
              countryCodeEditable={false}
              value={formik.values.phonenumber}
            
              onChange={(value, country) => {
                formik.setFieldValue('phonenumber', value);
                formik.setFieldValue('countryCode', `+${country.dialCode}`);
              }}
              inputClass="form-control"
              specialLabel=""
              inputProps={{
                name: 'phonenumber',
                onBlur: formik.handleBlur,
                  autoComplete:"off",
              }}
            />
            {formik.touched.phonenumber && formik.errors.phonenumber && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.phonenumber}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              E-mail Address<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter E-mail Address"
              autoComplete="adress"
              value={formik.values.email}
              name="email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={isEditMode}
            />
            {formik.touched.email && formik.errors.email && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.email}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Profile Picture<span className="text-danger">*</span>
            </label>

            <Uploader
              accept=".jpeg,.jpg,.png"
              multiple={false}
              fileListVisible={true}
              fileList={fileList}
              onChange={(fileList) => {
                console.log(fileList);
                let file;
                if(fileList?.length > 1) file = fileList?.[1]?.blobFile;
                else file = fileList?.[0]?.blobFile || null;
                formik.setFieldValue("ProfilePicture", file);
              }}
              onRemove={() => formik.setFieldValue("ProfilePicture", null)}
              action=""
              autoUpload={false}
            >
              <Button
                className="form-control"
                style={{
                  width: "100%",
                  height: "2.5rem",
                  fontSize: "0.875rem",
                  fontWeight: "400",
                  lineHeight: "1.5",
                  color: "#6c757dca",
                }}
              >
                Click to select file
              </Button>
            </Uploader>

            {formik.touched.ProfilePicture && formik.errors.ProfilePicture && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.ProfilePicture}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Languages Known<span className="text-danger">*</span>
            </label>

            <MultiSelect
              name="languagesknown"
              value={formik.values.languagesknown}
              onChange={(e) => formik.setFieldValue("languagesknown", e.value)}
              onBlur={formik.handleBlur}
              options={languages}
              optionLabel="name"
              optionValue="name"
              placeholder="Select Languages"
              maxSelectedLabels={3}
              className="w-full md:w-20rem multiselect-24px border p-2"
            />


            {formik.touched.languagesknown && formik.errors.languagesknown && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.languagesknown}
              </div>
            )}
          </div>
        </div>


        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Reffered By
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Refferal"
              value={formik.values.refferedby}
              name="refferedby"
             autoComplete="off"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.refferedby && formik.errors.refferedby && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.refferedby}
              </div>
            )}
          </div>
        </div>

        <div class="col-12 col-md-12">
          <div class="mb-3">
            <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
              <label class="col-form-label abt-pr">
                {" "}
                Office/Clinic Address<span class="text-danger">*</span>{" "}
              </label>
            </div>
            <textarea
              class="form-control"
              placeholder="Description yourself..."
              style={{
                color: "rgb(66, 66, 66)",
                height: "110px",
                letterSpacing: "0.5px",
                fontSize: "0.9rem",
                padding: "0.8rem",
                lineHeight: "1.7",
              }}
              name="address"
               
               autoComplete="addressesa"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            ></textarea>

            {formik.touched.address && formik.errors.address && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.address}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorAddBasicInfo;
